import React from 'react';

interface Props {
  mode?: 'list' | 'card';
}

const placeholders = Array.from({ length: 7 });

const QuotationProductPlaceholder: React.FC<Props> = ({ mode = 'list' }) => {
  // =====================================================
  // 🔹 Card Mode
  // =====================================================

  if (mode === 'card') {
    return (
      <div
        className="
          grid
          grid-cols-2
          gap-3

          sm:grid-cols-3
          md:grid-cols-4
          xl:grid-cols-5
          2xl:grid-cols-5
        "
      >
        {placeholders.map((_, index) => (
          <div
            key={index}
            className="
              overflow-hidden

              rounded-xl
              border

              border-stroke

              bg-whiten

              shadow-default

              dark:border-strokedark
              dark:bg-boxdark
            "
          >
            {/* ===================================================== */}
            {/* 🔹 Image */}
            {/* ===================================================== */}

            <div
              className="
                h-[150px]

                bg-slate-200

                dark:bg-meta-4
              "
            />

            {/* ===================================================== */}
            {/* 🔹 Content */}
            {/* ===================================================== */}

            <div className="space-y-3 p-4">
              {/* Código */}

              <div
                className="
                  h-3
                  w-16

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              {/* Nombre */}

              <div
                className="
                  h-4
                  w-full

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              <div
                className="
                  h-4
                  w-2/3

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              {/* Precio */}

              <div
                className="
                  h-5
                  w-24

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              {/* Stock */}

              <div
                className="
                  h-3
                  w-20

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  // =====================================================
  // 🔹 List Mode
  // =====================================================

  return (
    <div className="space-y-2">
      {placeholders.map((_, index) => (
        <div
          key={index}
          className="
            overflow-hidden

            rounded-xl
            border

            border-stroke

            bg-whiten

            shadow-default

            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <div
            className="
              flex
              h-[88px]
              items-center

              px-4
            "
          >
            {/* ===================================================== */}
            {/* 🔹 Image */}
            {/* ===================================================== */}

            <div
              className="
                h-14
                w-14

                rounded-xl

                bg-slate-200

                dark:bg-meta-4
              "
            />

            {/* ===================================================== */}
            {/* 🔹 Content */}
            {/* ===================================================== */}

            <div className="ml-4 flex-1 space-y-2">
              <div
                className="
                  h-4
                  w-2/5

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              <div
                className="
                  h-3
                  w-1/4

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />
            </div>

            {/* ===================================================== */}
            {/* 🔹 Price */}
            {/* ===================================================== */}

            <div
              className="
                h-5
                w-20

                rounded

                bg-slate-200

                dark:bg-meta-4
              "
            />

            {/* ===================================================== */}
            {/* 🔹 Stock */}
            {/* ===================================================== */}

            <div
              className="
                ml-6

                h-8
                w-24

                rounded-lg

                bg-slate-200

                dark:bg-meta-4
              "
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuotationProductPlaceholder;
